import { render } from "./course-certificate.vue?vue&type=template&id=19d515ba&ts=true"
import script from "./course-certificate.vue?vue&type=script&lang=ts"
export * from "./course-certificate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__